import { PricerAssignment } from '../types';
import editAssignmentIcon from '../assets/edit-assignment.svg';
import removeAssignmentIcon from '../assets/remove-assignment.svg';
import styles from '../SetupIpaPricingResponsibilities.module.scss';

type AssignmentRowProps = {
  assignment: PricerAssignment;
  onEdit: (assignment: PricerAssignment) => void;
  onRemove: (assignment: PricerAssignment) => void;
};

export const AssignmentRow = ({ assignment, onEdit, onRemove }: AssignmentRowProps) => (
  <article className={styles['assignment-row']}>
    <div className={styles['assignment-row__top']}>
      <div className={styles.identity}>
        <strong>{assignment.userName}</strong>
        <span>{assignment.userEmail}</span>
      </div>

      <div className={styles.actions}>
        <button type="button" onClick={() => onEdit(assignment)}>
          <span className={`${styles['action-icon']} ${styles['action-icon--edit']}`}>
            <img src={editAssignmentIcon} alt="" aria-hidden="true" />
          </span>
          Editar
        </button>
        <button type="button" onClick={() => onRemove(assignment)}>
          <span className={`${styles['action-icon']} ${styles['action-icon--remove']}`}>
            <img src={removeAssignmentIcon} alt="" aria-hidden="true" />
          </span>
          Remover
        </button>
      </div>
    </div>

    <div className={styles.tags}>
      {assignment.categories.map(category => (
        <span key={category} className={styles.tag}>
          {category}
        </span>
      ))}
    </div>
  </article>
);
